<template>
<form @submit.prevent="validateData()" method="POST" id="signup" class="login100-form validate-form flex-sb flex-w">
  <h1 class="login100-form-title p-b-25">{{$t('signup.registerText')}}</h1>
  <!-- <a href="#" class="btn-face m-b-15"><font-awesome-icon :icon="['fab', 'facebook']" size="2x"/>&nbsp;&nbsp;Facebook</a> -->
  <g-signin-button :params="googleSignInParams" class="btn-google m-b-15" @success="googleSignInSuccess" @error="googleSignInError"><img src="../../assets/img/icons/icon-google.png" alt="GOOGLE">Google</g-signin-button>
  <div><hr></div>
  <div class="p-t-10 p-b-10">
    <label for="email" class="txt1">Email</label>
  </div>
  <div class="field wrap-input">
    <input class="is-shadowless input100" id="email" name="email" type="email" v-model="user.email" :placeholder="$t('login.emailPlaceholder')" required>
  </div>
  <div class="p-t-10 p-b-10">
    <label for="password" class="txt1">{{$t('signup.password')}}</label>
  </div>
  <div class="field wrap-input">
    <vue-password v-model="user.password" classes="input100" :user-inputs="[user.email]" :strengthMessages="strengthMessages" required></vue-password>
  </div>
  <div class="container-login100-form-btn m-t-17">
    <button class="login100-form-btn">{{$t('signup.registerButton')}}</button>
  </div>
  <p class="is-size-7" v-html="$t('signup.acceptTerms')"></p>
  <div class="w-full text-center p-t-50">
    <a @click="goTo('login')" class="is-size-7 has-text-black">{{$t('signup.haveAccount')}}&nbsp;&nbsp;<span class="button is-info is-outlined is-small">{{$t('signup.login')}}</span></a>
  </div>
</form>
</template>
<script>
import VuePassword from 'vue-password'
import VueGkValidate from 'vue-gk-validator'
import performanceService from '@/services/performanceService'
import { xMisc } from '@/mixins/xMisc.js'
export default {
  name: 'signup',
  mixins: [xMisc],
  data () {
    return {
      isLoading: false,
      isFullPage: false,
      user: {
        email: '',
        password: '',
        status: 0,
        company_id: null
      },
      strengthMessages: [
        this.$t('signup.veryWeakMessage'),
        this.$t('signup.weakMessage'),
        this.$t('signup.mediumMessage'),
        this.$t('signup.goodMessage'),
        this.$t('signup.greatMessage')
      ]
    }
  },
  created () {
    this.getUrlQuery()
  },
  methods: {
    async validateData () {
      this.start()
      if (VueGkValidate.validate('email', this.user.email)) {
        var verify = await performanceService.getUserByEmail(this.user)
        if (verify.data.user != null) {
          this.stop()
          this.alert('danger', this.$t('signup.emailRegistered'))
        } else {
          if (this.$session.has('i')) {
            this.user.status = 1
            this.user.company_id = this.$session.get('i')
          }
          this.register()
        }
      } else {
        this.stop()
        this.alert('danger', this.$t('general.notValidEmail'))
      }
    },
    async register () {
      var r = await performanceService.register(this.user)
      if (r.data.success) {
        this.$session.start()
        this.$session.set('user', r.data.user)
        var user = this.$session.get('user')
        if (user.st > 0) {
          location.href = 'home'
        } else {
          location.href = 'get-started'
        }
      } else {
        this.alert('danger', this.$t('signup.emailRegistered'))
      }
    }
  },
  components: {
    VuePassword
  }
}
</script>



// WEBPACK FOOTER //
// src/components/client/Signup.vue